import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
import { Reveal } from './Reveal';
const reassurances = ['Descarga instantánea tras el pago', 'Un solo pago, sin suscripciones', 'Acceso de por vida a los 12 niveles', 'Garantía de 7 días sin preguntas'];
export function Offer() {
  return <section id="offer" className="relative w-full overflow-hidden bg-ink px-5 py-20 sm:py-28" data-id="element-175" data-mp="tyv67diymhys">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-176" data-mp="ozrzlonc03op" />
      <div className="relative mx-auto max-w-xl" data-id="element-177" data-mp="p1l693xy2nwp">
        <Reveal className="text-center" data-id="element-178" data-mp="13xkfihwsiu3f">
          <span className="inline-flex rounded-full bg-volt px-4 py-1.5 font-display text-xs tracking-[0.16em] text-ink" data-id="element-179" data-mp="13yc9joaqojrl">
            Oferta especial de lanzamiento
          </span>
          <h2 className="balance mt-6 font-display text-[2.4rem] leading-[0.98] text-white sm:text-[3.4rem]" data-id="element-180" data-mp="2fav52trw64ti">
            Kit INGLES LISTO™{' '}
            <span className="text-brand" data-id="element-181" data-mp="pk7gbmti0n9z">completo</span>
          </h2>
        </Reveal>

        <Reveal delay={0.06} data-id="element-182" data-mp="pmbl06z81qbb">
          <div className="relative mt-12 rounded-3xl border-2 border-ink bg-white px-6 pb-8 pt-12 shadow-lift sm:px-9" data-id="element-183" data-mp="uisgxncnx8yy">
            <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full border-2 border-ink bg-brand px-5 py-1.5 font-display text-xs tracking-[0.14em] text-white" data-id="element-184" data-mp="zjg603hbzfqj">
              12 volúmenes + 5 bonos
            </span>

            <dl data-id="element-185" data-mp="6rwi469shdi7">
              {offerRows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-b border-ink/10 py-4" data-id="element-186" data-mp="bs12i7dtisdp">
                  <dt className="text-base leading-snug text-ink/75" data-id="element-187" data-mp="ftmabebhwgh1">
                    {row.label}
                  </dt>
                  <dd className="shrink-0 font-bold text-ink/40 line-through" data-id="element-188" data-mp="kn8ml5dqyicb">
                    {row.value}
                  </dd>
                </div>)}
              <div className="flex items-center justify-between gap-4 border-b-2 border-ink py-4" data-id="element-189" data-mp="3o9frzwhkbxzo">
                <dt className="font-display text-lg text-ink" data-id="element-190" data-mp="vez3sxww5r53">Valor total</dt>
                <dd className="shrink-0 font-display text-lg text-ink/40 line-through" data-id="element-191" data-mp="qgxl4e3dntu5">
                  $171 USD
                </dd>
              </div>
            </dl>

            <p className="mt-8 text-center font-display text-sm tracking-[0.18em] text-brand" data-id="element-192" data-mp="157d4rog5atq7">
              Solo por hoy
            </p>
            <p className="mt-2 text-center" data-id="element-193" data-mp="cg36vetneynk">
              <span className="inline-flex items-baseline justify-center gap-2" data-id="element-194" data-mp="ch4usjvrjfmp">
                <span className="font-display text-[4.5rem] leading-none text-ink sm:text-[5.5rem]" data-id="element-195" data-mp="7jcryutky93q">
                  $17
                </span>
                <span className="font-display text-2xl leading-none text-ink/50 sm:text-3xl" data-id="element-196" data-mp="hfzctjlwp05r">
                  USD
                </span>
              </span>
              <span className="mt-2 block text-sm font-bold uppercase tracking-[0.16em] text-ink/50" data-id="element-197" data-mp="1wv5616mev0cs">
                Pago único
              </span>
              <span className="mx-auto mt-3 block max-w-xs text-xs font-semibold leading-relaxed text-ink/45" data-id="element-198" data-mp="20exbwbz1wbzb">
                El cobro se hace en la moneda de tu país, con la conversión
                automática del día.
              </span>
            </p>

            <CtaButton label="¡Quiero mi Kit ahora!" className="mt-8 w-full" data-id="element-199" data-mp="1qiartpejtoyc" />

            <p className="mt-4 flex items-center justify-center gap-2 text-xs text-ink/50" data-id="element-200" data-mp="1vg2sb7t9eje5">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-201" data-mp="2j6g9226e8vtf" />
              <span data-id="element-202" data-mp="2o4riwcwov6bn">Pago 100% seguro y encriptado</span>
            </p>

            <ul className="mt-6 space-y-2.5" data-id="element-203" data-mp="2o62ngexyki3t">
              {reassurances.map(item => <li key={item} className="flex items-center gap-2.5 text-sm font-semibold text-ink/70" data-id="element-204" data-mp="29f243evob3sw">
                  <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-volt" data-id="element-205" data-mp="2eclwrjt4bj4d">
                    <CheckIcon className="h-3 w-3 text-ink" aria-hidden="true" strokeWidth={3} data-id="element-206" data-mp="3226clttz609f" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}